/**
 * 跟车人数下拉选项
 */
export const escortCountOptions = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
];
